module.exports = __webpack_public_path__ + "static/assets/797da41ea8725ca406d63babf790766e.png";